import { get, post } from './axios'

//////////////////////////////////////////////////////////////////////
// GET
//////////////////////////////////////////////////////////////////////

/**
 * getAccountTransferEditParams
 */

export type GetAccountTransferEditParamsResponseData = {
  baseURL: string
  version: string
  bill_method: string
  kessai_id: string
  shop_cd: string
  syuno_co_cd: string
  shop_pwd: string
  koushin_kbn: string
  bill_no: string
  bill_name: string
  bill_kana: string
  bill_mail: string
  bill_mail_kbn: string
  shop_name: string
  shop_phon: string
  shop_phon_hyoji_kbn: string
  shop_mail: string
  shop_mail_hyoji_kbn: string
}

export const getAccountTransferEditParams = async (userId: number) => {
  return await get<GetAccountTransferEditParamsResponseData>(
    `/v1/users/${userId}/paymentMethods/accountTransferEditParams`,
  )
}

/**
 * getCreditCardEditURL
 */

export const getCreditCardEditURL = async (userId: number) => {
  return await get<{ url: string }>(`/v1/users/${userId}/paymentMethods/creditCardEditURL`)
}

//////////////////////////////////////////////////////////////////////
// GET
//////////////////////////////////////////////////////////////////////

/**
 * request
 */

export const PaymentMethodRequestType = {
  CreditCard: 0,
  AccountTransfer: 1,
} as const
export type PaymentMethodRequestType = (typeof PaymentMethodRequestType)[keyof typeof PaymentMethodRequestType]

export type RequestParams = {
  userId: number
  type: PaymentMethodRequestType
  postalCode: string
  address: string
  name: string
}

export const request = async ({ userId, ...body }: RequestParams) => {
  return await post(`/v1/users/${userId}/paymentMethods/request`, body)
}
